import React, { useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import {
  useAddServiceMutation,
  useUpdateServiceMutation,
} from "../../Data/services/serviceApi";
import { useUploadAttachmentMutation } from "../../Data/services/uploadAttachmentApi";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import { Button, Input, SubTitle } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import {
  useAddCategoryMutation,
  useUpdateCategoryMutation,
} from "../../Data/services/categoryApi";
import ClipLoader from "react-spinners/ClipLoader";
import { MdDeleteForever } from "react-icons/md";
import ToolTip from "../CustomComponents/ToolTip";
import { RiEditFill } from "react-icons/ri";

const EditSubCategoriesModal = ({
  handleEditModalClose,
  editData,
  setDeletedData,
  handleDeleteModalOpen,
  refetch,
}) => {
  const [parentId, setParentId] = useState("");
  const [category, setCategory] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [imageFile, setImageFile] = useState("");
  const [imagePreview, setImagePreview] = useState("");
  const [sending, setSending] = useState(false);
  const [editedData, setEditedData] = useState(null);
  const [rowId, setRowId] = useState("");

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (editData) {
      // console.log(editData);
      setParentId(editData.id);
    }
  }, [editData, mounted]);

  useEffect(() => {
    if (editedData) {
      // console.log(editedData);
      setRowId(editedData.id);
      setCategory(editedData.name);
      setImagePreview(editedData.image_url || "");
      setImageUrl(editedData.image_url || "");
    }
  }, [editedData, mounted]);

  const handleDelete = () => {
    // console.log(editedData);
    setDeletedData(editedData); // Pass the ID back to parent
    handleDeleteModalOpen(); // Then open the delete modal
  };

  const handleCategoryChange = (lang) => (e) => {
    setCategory(e.target.value);
  };

  const [uploadAttachment, { isLoading: isUploading }] =
    useUploadAttachmentMutation();

  const handleImagePreview = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleImageUpload = async (e) => {
    const formData = new FormData();
    formData.append("file", imageFile);
    formData.append("path", "category");

    // Loop through formData
    for (let [key, value] of formData.entries()) {
      console.log(key, value);
    }

    try {
      const response = await uploadAttachment({ formData }).unwrap();
      console.log(response);
      return response.data[0];
    } catch (error) {
      Toast("Failed to upload image", "error");
    }
  };

  const [addCategory, { isLoading: adding }] = useAddCategoryMutation();
  const [updateCategory, { isLoading: updating }] = useUpdateCategoryMutation();

  const handleSubmit = async () => {
    console.log(rowId);
    // console.log(category);
    // console.log(imageUrl);

    if (!category || category.length < 3) {
      Toast("Minimum 3 characters required in English name.", "error");
      return;
    }

    setSending(true);
    try {
      let imageName;
      if (imageFile) {
        imageName = await handleImageUpload();
      }

      const data = {
        name: category,
        parent_id: parentId,
        image_url: imageName || imageUrl || "", // already uploaded image URL
      };

      let response;
      if (editedData) {
        response = await updateCategory({ data, id: rowId }).unwrap();
      } else {
        response = await addCategory(data).unwrap();
      }

      console.log(response);

      if (response.code === 200) {
        refetch();
        setSending(false);
        SuccessToast(response?.message);
        handleEditModalClose();
      }
    } catch (error) {
      console.log(error);
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
      handleEditModalClose();
      setSending(false);
    }
  };

  if (!mounted) {
    return;
  }

  return (
    <div>
      <ModalContainer handleClose={handleEditModalClose}>
        <div
          className={cssStyles.modalContainer}
          style={{ maxWidth: "90dvw", minHeight: "90dvh" }}
        >
          <Row className="w-100">
            {/* MARK: Left Column */}
            <Col md={6}>
              <SubTitle classes="mb-4 text-center" text={editData.name} />
              <table className="table table-striped ">
                <thead>
                  <tr>
                    <th>Sub Category Name</th>
                    <th>Image</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {editData.sub_categories.length <= 0 ? (
                    <tr>
                      <td colSpan={3} className="text-center">
                        No Sub Categories Found
                      </td>
                    </tr>
                  ) : (
                    editData.sub_categories.map((subCategory, index) => {
                      return (
                        <tr>
                          <td>{subCategory.name}</td>
                          <td>
                            <img
                              src={
                                subCategory.image_url ||
                                "https://placehold.co/100x100"
                              }
                              alt={subCategory.name}
                              width={100}
                              height={100}
                              className="rounded"
                            />
                          </td>
                          <td>
                            <div className="d-flex justify-content-center align-items-center ">
                              <ToolTip placement={"top"} content={"Edit"}>
                                <div
                                  className={` d-flex justify-content-center align-items-center bg-primary-hover rounded-3 p-2 mx-2 `}
                                  role="button"
                                  onClick={() => {
                                    setEditedData(subCategory);
                                    // handleEditModalOpen(true);
                                  }}
                                >
                                  <span
                                    className={`align-items-center d-flex justify-content-center `}
                                  >
                                    <RiEditFill />
                                  </span>
                                  {/* <span>Edit</span> */}
                                </div>
                              </ToolTip>

                              <ToolTip placement={"top"} content={"Delete"}>
                                <div
                                  className="d-flex justify-content-center align-items-center bg-danger-hover rounded-3 p-2 mx-2 "
                                  role="button"
                                  onClick={() => {
                                    setEditedData(subCategory);
                                    handleEditModalClose();
                                    // setDeletedData(subCategory.id);
                                    // handleDeleteModalOpen();
                                    handleDelete();

                                    // handleDeleteModalOpen();
                                  }}
                                >
                                  <span className={`d-flex align-items-center`}>
                                    <MdDeleteForever />
                                  </span>
                                  {/* <span>Delete</span> */}
                                </div>
                              </ToolTip>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </Col>
            {/* MARK: Right Column */}
            <Col md={6}>
              <div className="d-flex align-items-center w-100 justify-content-between mb-4">
                <p className="fs-4 fw-medium m-0 ">
                  {editedData ? "Edit Sub Category" : "Add Sub Category"}
                </p>
                <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
                  <FaCircleXmark
                    role="button"
                    onClick={handleEditModalClose}
                    style={{ cursor: "pointer" }}
                  />
                </span>
              </div>
              <div className="w-100">
                <Row>
                  <Col md={12}>
                    <Input
                      classes="mt-2 mb-3"
                      type="text"
                      placeholder="Enter category name"
                      value={category}
                      onChange={handleCategoryChange("en")}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={9}>
                    <Input
                      classes="mt-2 mb-3"
                      type="file"
                      placeholder="Image"
                      onChange={(e) => {
                        // handleImageUpload(e);
                        handleImagePreview(e);
                      }}
                    />
                  </Col>

                  <Col md={3}>
                    {isUploading ? (
                      <Spinner />
                    ) : (
                      <img
                        src={
                          imagePreview ||
                          imageUrl ||
                          "https://placehold.co/100x100"
                        }
                        alt="category_image"
                        width={100}
                        height={100}
                        className="rounded"
                      />
                    )}
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <Button
                      classes={`mt-3 mb-2 ${
                        sending || category.length <= 3
                          ? "bg-dark-subtle"
                          : "shadow"
                      } `}
                      text={
                        sending ? (
                          <ClipLoader color="#0f0f0f" size="22px" />
                        ) : editedData ? (
                          "Update"
                        ) : (
                          "Save"
                        )
                      }
                      disabled={sending || category.length <= 3}
                      onClick={handleSubmit}
                    ></Button>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </ModalContainer>
    </div>
  );
};

export default EditSubCategoriesModal;
